import * as React from 'react';
import {connect} from "react-redux";
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import { Auth } from '../../Config/dataModel';
import util from '../../Util/util';
import * as moment from 'moment';

const closeIcon = require('../../resource/img/close-small.svg');

interface MaintenanceNotificationBoxProps {
    maintenanceTime: moment.Moment,
    hideMaintenance: () => void,
    auth: () => Auth
}

interface MaintenanceNotificationBoxState {
    display: boolean
}

class MaintenanceNotificationBox extends React.Component<MaintenanceNotificationBoxProps, MaintenanceNotificationBoxState> {
    public constructor(props: MaintenanceNotificationBoxProps) {
        super(props);
        this.state = {
            display: true,
        };
        this.clickClose = this.clickClose.bind(this);
    }

    public clickClose(event: React.MouseEvent<HTMLElement>) {
        this.props.hideMaintenance();
        this.setState({
            display: false
        });
    }

    public render() {
        return this.state.display && this.props.auth().displayMaintenance ?
            (
                <div className="maintenanceNotificationBox">
                    <div className="notificationBoxContainer">
                        <span>Maintenance is scheduled on {util.getMaintenanceDatetime(this.props.maintenanceTime)}.</span>
                        <br/>
                        <span className="notificationContent">Access to MIDAS will be temporarily unavailable. We apologize for any inconvenience caused.</span>
                    </div>
                    <button className="notificationBoxCloseBtn" onClick={this.clickClose}><img src={closeIcon}/></button>
                </div> 
            ) : null;
    }
}

export default connect(authState, authDispatch)(MaintenanceNotificationBox);



// WEBPACK FOOTER //
// ./src/Components/Maintenance/MaintenanceNotificationBox.tsx